import IconTextGroup from './IconTextGroup';
import { IconTextGroupProps, IconTextGroupValueProps } from './types';

export type { IconTextGroupProps, IconTextGroupValueProps };
export default IconTextGroup;
